import { useEffect } from "react";

// Store server-side field validation errors after submit
// into react-hook-form state to render accordingly
export function useServerFieldErrors(
  fetcher,
  formProps,
  { shouldReset = false } = {},
) {
  const { resetField, setError } = formProps;

  return useEffect(() => {
    if (
      fetcher &&
      fetcher.state === "idle" &&
      fetcher.data != null &&
      fetcher.data?.fieldErrors
    ) {
      fetcher.data.fieldErrors.forEach(({ fieldName, message }, index) => {
        if (shouldReset) {
          resetField(fieldName);
        }
        setError(
          fieldName,
          {
            type: "server",
            message,
          },
          // Focus on the first reported error
          { shouldFocus: index === 0 },
        );
      });
    }
  }, [fetcher.state, fetcher.data, resetField, setError, shouldReset]);
}
